import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './MyClasses.css';
import { getApiUrl, API_ENDPOINTS, getAuthHeaders } from '../../../config/api.config';

const MyClasses = () => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        console.log('Fetching classes...');
        const user = localStorage.getItem('user');
        const userData = JSON.parse(user);

        if (!userData || !userData.userId) {
          throw new Error('User data not found');
        }

        const response = await axios.get(
          getApiUrl(API_ENDPOINTS.STUDENT.CLASSES(userData.userId)),
          { headers: getAuthHeaders() }
        );

        console.log('Classes response:', response.data);

        if (response.data.success) {
          const classesData = response.data.classes || [];
          setClasses(classesData);
        } else {
          setClasses([]);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error:", error);
        // Only set actual errors, not the "no classes" message
        if (error.response?.data?.message && 
            error.response.data.message !== "No enrolled classes found for this student") {
          setError(error.response.data.message || "Failed to load classes");
        } else {
          setClasses([]);
        }
        setLoading(false);
      }
    };

    fetchClasses();
  }, []);

  const handleClassClick = async (classItem) => {
    try {
      // Set loading state for better UX
      setLoading(true);
      
      // Make API request to fetch questions for the class using the API config
      const response = await axios.get(
        getApiUrl(`/api/v1/stem@home/class/${classItem._id}/questions`),
        { headers: getAuthHeaders() }
      );
      
      console.log('Questions response:', response.data);
      
      // Navigate to student class page instead of class-details
      navigate(`/student/class/${classItem._id}`, {
        state: {
          className: classItem.name,
          teacherName: classItem.teacher?.name || 'Not assigned',
          questions: response.data.questions || []
        }
      });
    } catch (error) {
      console.error("Error fetching questions:", error);
      setError("Failed to load class questions. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="my-classes-container">
      <div className="loading">Loading classes...</div>
    </div>;
  }

  if (error) {
    return <div className="my-classes-container">
      <div className="error">{error}</div>
    </div>;
  }

  return (
    <div className="my-classes-container">
      <div className="classes-header">
        <h1>My Classes</h1>
      </div>

      <div className="classes-content">
        {(!classes || classes.length === 0) ? (
          <div className="empty-classes">
            <div className="empty-classes-icon">📚</div>
            <h3>No Classes Yet</h3>
            <p>You aren't enrolled in any classes at the moment.</p>
            <p className="empty-classes-hint">Once you're enrolled, your classes will appear here.</p>
          </div>
        ) : (
          <div className="classes-grid">
            {classes.map((classItem) => (
              <div 
                key={classItem._id} 
                className="class-card" 
                onClick={() => handleClassClick(classItem)}
              >
                <h3>{classItem.name}</h3>
                <p>Teacher: {classItem.teacher?.name || 'Not assigned'}</p>
                <p>Questions: {classItem.questions?.length || 0}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyClasses; 